import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=70c0456e&scoped=true&"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=70c0456e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c0456e",
  null
  
)

export default component.exports